<template lang="pug">
    mixin features
        div.container.has-text-centered.has-text-blue
            img.brand-logo(:src="'https://bo.herdadesaomiguel.com/assets/gamas/' + wine.imagem")
            h1.is-size-7.is-uppercase.has-letter-spacing-200 {{ wine.categoria_nome }}
            h2.is-size-28.is-uppercase {{ wine.referencia }}

            div.feature-block
                h3.is-size-7.is-uppercase.has-letter-spacing-200.has-text-blue-lighter {{ $t('page_04.datasheet.block_01.name') }}
                div.has-text-centered
                    div.liner.is-inline-block.has-background-blue

                h4.is-size-7.is-uppercase.has-letter-spacing-200 {{ $t('page_04.datasheet.block_01.field_01') }}
                p {{ wine.ano }}

                h4.is-size-7.is-uppercase.has-letter-spacing-200 {{ $t('page_04.datasheet.block_01.field_02') }}
                p {{ wine['soil_' + $i18n.locale] }}

                h4.is-size-7.is-uppercase.has-letter-spacing-200 {{ $t('page_04.datasheet.block_01.field_03') }}
                p(v-for="c in wine.castas") {{ c['nome_' + $i18n.locale] }}

                h4.is-size-7.is-uppercase.has-letter-spacing-200 {{ $t('page_04.datasheet.block_01.field_04') }}
                p {{ wine['vinificacao_' + $i18n.locale] }}

                h4.is-size-7.is-uppercase.has-letter-spacing-200 {{ $t('page_04.datasheet.block_01.field_05') }}
                p {{ wine['estagio_' + $i18n.locale] }}

                h4.is-size-7.is-uppercase.has-letter-spacing-200 {{ $t('page_04.datasheet.block_01.field_06') }}
                p
                    span.is-size-7.is-uppercase {{ $t('page_04.datasheet.block_01.field_06_01') }} |
                    span  {{ wine.analise_alcool }}

                p
                    span.is-size-7.is-uppercase {{ $t('page_04.datasheet.block_01.field_06_02') }} |
                    span  {{ wine.analise_total }}

                p
                    span.is-size-7.is-uppercase {{ $t('page_04.datasheet.block_01.field_06_03') }} |
                    span  {{ wine.analise_ph }}

                p
                    span.is-size-7.is-uppercase {{ $t('page_04.datasheet.block_01.field_06_04') }} |
                    span  {{ wine.analise_volatil }}

            div.feature-block
                h3.is-size-7.is-uppercase.has-letter-spacing-200.has-text-blue-lighter {{ $t('page_04.datasheet.block_02.name') }}
                div.has-text-centered
                    div.liner.is-inline-block.has-background-blue

                h4.is-size-7.is-uppercase.has-letter-spacing-200 {{ $t('page_04.datasheet.block_02.field_01') }}
                p {{ wine['nota_prova_cor_' + $i18n.locale] }}

                h4.is-size-7.is-uppercase.has-letter-spacing-200 {{ $t('page_04.datasheet.block_02.field_02') }}
                p {{ wine['nota_prova_aroma_' + $i18n.locale] }}

                h4.is-size-7.is-uppercase.has-letter-spacing-200 {{ $t('page_04.datasheet.block_02.field_03') }}
                p {{ wine['nota_prova_paladar_' + $i18n.locale] }}

                h4.is-size-7.is-uppercase.has-letter-spacing-200 {{ $t('page_04.datasheet.block_02.field_04') }}
                p {{ wine['acompanha_' + $i18n.locale] }}

                h4.is-size-7.is-uppercase.has-letter-spacing-200 {{ $t('page_04.datasheet.block_02.field_05') }}
                p {{ wine['disponivel_' + $i18n.locale] }}

                // h4.is-size-7.is-uppercase.has-letter-spacing-200(v-if="prizes.length")  {{ $t('page_04.datasheet.block_03.name') }}
                // p(v-for="p in prizes", v-if="prizes.length") {{ p }}

            div.feature-block(v-if="wine.prizes.length")
                h3.is-size-7.is-inline-block.is-uppercase.has-letter-spacing-200 {{ $t('page_04.datasheet.block_03.name') }}
                span
                    div.dropdown.is-hoverable
                        div.dropdown-trigger
                            span.dropdown-middle.is-pointer
                                span.is-size-7.is-uppercase {{ selectedYear }}
                                i.is-size-7.fas.fa-angle-down.fa-lg
                        div.dropdown-menu
                            div.dropdown-content
                                ul
                                    li.is-size-7.is-pointer(v-for="year in wine.prizes.map(p => p.year).filter((x, i, a) => a.indexOf(x) === i).sort().reverse()", :key="year", @click="selectedYear = year") {{ year }}

                div.has-text-centered
                    div.liner.is-inline-block.has-background-blue
                p(v-for="p in wine.prizes.filter(i => i.year === selectedYear)") {{ p.name }} | {{ p['text_' + $i18n.locale] }}

    transition(enter-active-class="animated slideInLeft fast", leave-active-class="animated slideOutRight fast", appear)
        section.datasheet-wrapper.has-background-white(ref="datasheet")
            div.columns.is-gapless.is-marginless.is-fullheight-desktop

                //- column left
                div.column.is-relative.has-background-white-ter(v-if="wine")
                    div.columns.is-vcentered.is-gapless.has-text-centered.is-fullheight-desktop
                        div.column.is-3.is-hidden-touch
                            p.is-size-11.has-letter-spacing-200.is-uppercase.has-rotation-left.is-pointer.is-hover-bold(@click="$emit('change-wine', -1)") {{ $t('page_04.datasheet.button_01.text') }}
                        div.column
                            img.is-bottle(:src="'https://bo.herdadesaomiguel.com/assets/vinhos/' + wine.id + '.png'")
                        div.column.is-3.is-hidden-touch
                            p.is-size-11.has-letter-spacing-200.is-uppercase.has-rotation-right.is-pointer.is-hover-bold(@click="$emit('change-wine', 1)") {{ $t('page_04.datasheet.button_02.text') }}

                    div.is-share
                        div.columns.is-mobile
                            div.column
                                div.is-pointer.is-relative(@mouseover="share_hover = true", @mouseleave="share_hover = false")
                                    transition(enter-active-class="animated fadeIn fast", leave-active-class="animated fadeOut faster", appear)
                                        div.social-buttons(v-if="share_hover")
                                            div
                                                a(:href="'https://twitter.com/intent/tweet?text=' + url" target="_blank")
                                                    img.social-buttons-link(src="../assets/images/4_vinhos/botoes/Share_Twitter.svg")
                                            div
                                                a(:href="'https://www.facebook.com/sharer/sharer.php?u=' + url" target="_blank")
                                                    img.social-buttons-link(src="../assets/images/4_vinhos/botoes/Share_Facebook.svg")

                                    img.btn.share(src="../assets/images/4_vinhos/botoes/Share.svg", v-if="!share_hover")
                                    img.btn.share(:src="require('../assets/images/4_vinhos/botoes/Share_hover_' + $i18n.locale + '.svg')", v-else)
                            div.column.has-text-right
                                span.is-pointer(@mouseover="ficha_hover = true", @mouseleave="ficha_hover = false")
                                    img.btn.ficha(src="../assets/images/4_vinhos/botoes/Ficha tecnica.svg", v-if="!ficha_hover")
                                    a(:href="datasheetName", target="_blank", v-else)
                                        img.btn.ficha(:src="require('../assets/images/4_vinhos/botoes/Ficha tecnica_hover_' + $i18n.locale + '.svg')")

                //- column right
                div.column.features(v-if="wine")
                    div.datasheet-close.is-pointer(@click="close")
                        img.datasheet-close-icon(src="../assets/images/4_vinhos/botoes/close_hover.svg")
                    +features
                    img.is-block.is-fullw(src="../assets/images/4_vinhos/foto_footer.jpg")

                div.column.is-hidden-desktop(v-if="wine")
                    div.columns.datasheet-control-mobile.is-mobile
                        div.column.is-narrow
                            p.is-size-11.has-letter-spacing-200.is-uppercase(@click="$emit('change-wine', -1); scrollTop()") {{ $t('page_04.datasheet.button_01.text') }}
                        div.column.has-text-centered
                            div.is-pointer(@click="close")
                                img.datasheet-close-icon(src="../assets/images/4_vinhos/botoes/close_hover.svg")
                        div.column.is-narrow
                            p.is-size-11.has-letter-spacing-200.is-uppercase(@click="$emit('change-wine', 1); scrollTop()") {{ $t('page_04.datasheet.button_02.text') }}

</template>

<script>

export default {
    name: 'wine-features',
    props: {
        w: Object
    },
    data () {
        return {
            share_hover: false,
            ficha_hover: false,
            close_hover: false,
            selectedYear: null,
            wine: this.w
        }
    },
    computed: {
        datasheetName () {
            return `http://www.casarelvas.pt/fichas/${this.wine.id}-${this.$i18n.locale}.pdf`
        },

        url () {
            return window.location.origin + this.$route.path + '/' + this.wine.id
        }
    },
    async created () {
        document.body.style.overflowY = 'hidden'

        if (!this.w) {
            const params = { brand_id: this.$route.params.id }
            const wines = await this.$api.getWines(params)
            this.wine = wines.find(w => +w.id === +this.$route.params.wineid)
        }

        if (this.wine.prizes.length) {
            this.selectedYear = this.wine.prizes.reduce((selected, { year }) => Math.max(+selected, +year), 0)
        }
    },
    destroyed () {
        document.body.style.overflowY = 'auto'
    },
    methods: {
        scrollTop () {
            this.$refs.datasheet.scrollTop = 0
        },

        close () {
            this.$route.params.wineid ? this.$router.push({ path: '/' }) : this.$emit('close')
        }
    }
}
</script>

<style lang="stylus" scoped>

.datasheet-wrapper
    width 100vw
    height 100vh
    z-index 100
    position fixed
    top 0
    left 0

    @media screen and (max-width 768px)
        overflow-y scroll

.features
    overflow auto
    border-left 1px solid #DAE1EA

.datasheet-close
    position absolute
    top 1.5rem
    right 2.5rem
    z-index 1

.datasheet-close-icon
    width 1rem

.datasheet-control-mobile
    padding 25px 5px

.is-fullheight-desktop
    @media screen and (min-width 1025px)
        height 100%

.container
    max-width 500px !important
    h1 + h2
        margin-top 0.5rem

    h3 ~ h4
        margin-top 1.5rem
        margin-bottom 0.5rem
    p + h4
        margin-top 2.8125rem

.has-rotation-left
    @media screen and (min-width 1025px)
        transform: rotate(-90deg)

.has-rotation-right
    @media screen and (min-width 1025px)
        transform: rotate(90deg)

.liner
    width 1px
    height 2.1875rem
    margin-top 1.25rem

.is-bottle
    padding 1rem
    max-height 90vh

    @media screen and (max-width 1024px)
        max-height 300px

.brand-logo
    width 10vw

    @media screen and (max-width 768px)
        width 50vw

.is-share
    position absolute
    bottom 0
    left 0

    width 100%
    padding 50px

    @media screen and (max-width: 768px)
        padding 15px

    .btn
        &.ficha
            max-width 11.5rem
        &.share
            max-width 10rem

.is-hover-bold:hover
    font-weight 600

.dropdown
    height 100%

.dropdown-trigger
    min-width 5rem

.dropdown-middle
    height 100%
    display inline-flex
    align-items center
    justify-content center
    border-bottom 2px solid transparent

    span + i
        margin-left 10px

.dropdown-menu
    min-width inherit
    width 100%
    padding-top 0

.dropdown-content
    border-radius 0
    box-shadow none
    padding 1rem 0

    li + li
        margin-top 1rem

.feature-block
    margin-top 4.6875rem

.social-buttons
    position absolute
    top 0
    left 0
    margin-top -82px
    padding-left 12px
    padding-bottom 50px

    @media screen and (max-width 1024px)
        margin-top -60px
        padding-left 8px

    &-link
        width 2.375rem
</style>
